import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import { DropDownOptionElementProps } from "./DropDownOptionElement.types";
import { CheckIcon } from "../../../../../../icons";

const DropDownOptionElement = <T,>({
  children,
  option,
  index,
  selectedElement,
  setSelectedElement,
  onSelect,
  disabled,
  wrapperOptions,
  selectedOption,
  ...rest
}: DropDownOptionElementProps<T>) => {
  const [optionRef, setOptionRef] = React.useState<HTMLDivElement | null>(null);

  React.useEffect(() => {
    if (optionRef) {
      optionRef.setAttribute("data-option-index", String(index));
    }
  }, [optionRef]);

  return (
    <Box
      py={4}
      px={4}
      backgroundColor={selectedElement === index ? "bg.grey" : "bg.white"}
      _hover={!disabled ? { cursor: "pointer" } : undefined}
      onMouseEnter={() => setSelectedElement?.(index)}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (disabled) return;
        onSelect && onSelect(option);
      }}
      {...rest}
      {...wrapperOptions}
      ref={setOptionRef}
    >
      <Flex w={"100%"} alignItems={"center"}>
        <Box flexGrow={1}>{children}</Box>
        {selectedOption && selectedOption.value === option.value && (
          <Box>
            <CheckIcon color={"brand.main"} />
          </Box>
        )}
      </Flex>
    </Box>
  );
};

const genericMemo: <T>(component: T) => T = React.memo;

export default genericMemo(DropDownOptionElement);
